import React, { Fragment, useLayoutEffect } from "react";
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { VIEW_PATH } from "../../../../config/paths";
import Content from "../../../layout/Content";
import Loader from "../../../common/Loader";
import NoDataResource from "../../../common/resource/NoDataResource";
import ResourceProperty from "../../../common/resource/ResourceProperty";
import InternalResource from "../../../common/resource/InternalResource";
import { Col, Row } from "reactstrap";
import ViewToolbar from "./ViewToolbar";
import { clearView, getView } from "../../../../actions/security/View";

const View = ({
  breadcrumbs,
  match: {
    params: { id },
  },
  view,
  loading,
  dispatchGetView,
  dispatchClearView,
}) => {
  useLayoutEffect(() => {
    dispatchGetView({ id });
    return () => dispatchClearView();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (view.isEmpty())
    content = <NoDataResource returnPage={VIEW_PATH} />;
  else {
    const viewJs = view.toJS();

    const basicInformationResource = (
      <Fragment>
        <h3>Información Básica</h3>
        <ResourceProperty label="Nombre:">
          {viewJs.name}
        </ResourceProperty>
        <ResourceProperty label="Descripción:">
          {viewJs.description || '-'}
        </ResourceProperty>
        <ResourceProperty label="Ruta:">
          {viewJs.route}
        </ResourceProperty>
      </Fragment>
    );

    const internalResource = (
      <InternalResource
        id={viewJs.id}
        createDate={viewJs.createDate}
        lastUpdate={viewJs.lastUpdate}
      />
    );

    content = (
      <>
        <Row>
          <Col md={6}>{basicInformationResource}</Col>
        </Row>
        <Row>
          <Col md={6}>{internalResource}</Col>
        </Row>
      </>
    );

    toolbar = (
      <ViewToolbar
        viewId={viewJs.id}
      />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Vista"
      content={content}
    />
  );
};

View.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetView: PropTypes.func.isRequired,
  dispatchClearView: PropTypes.func.isRequired,
  view: PropTypes.instanceOf(Immutable.Map).isRequired,
  match: matchPropTypes.isRequired,
  loading: PropTypes.bool,
};

const mapDispatchToProps = {
  dispatchGetView: getView,
  dispatchClearView: clearView,
};

View.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ SecurityUnit }) => ({
  breadcrumbs: [
    ...SecurityUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Vista',
      href: VIEW_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  view: SecurityUnit.View.getIn(['current', 'content']),
  loading: !SecurityUnit.View.getIn(['current', 'activity']).isEmpty(),
});


export default connect(mapStateToProps, mapDispatchToProps)(View);